import router from "@/router";

export default {
  namespaced: true,
  state: {
    selectProvinceId: [],
    recent_province: null,
    province: null,
    service: null,
    recentRoutePath: [
      {
        text: "Select province",
        disabled: true,
        href: "/weserve_admin_login/select/"
      }
    ],
    loading: false
  },
  mutations: {
    setSelectProvinceId(state, id) {
      state.selectProvinceId.push(id)
    },
    removeProvinceId(state, id) {
      let index = state.selectProvinceId.findIndex(val => val == id);
      state.selectProvinceId.splice(index, 1)
    },
    saveRecentRoute(state, path) {
      state.recentRoutePath = path;
    },
    selectProvince(state, province) {
      if (province != '-') {
        if (state.province != null) {
          state.recent_province = state.province;
        }
        state.province = province;
      }
    },
    showMenu(state, service) {
      state.service = service;
    },
    changeLoadingProgress(state, value) {
      state.loading = value;
    }
  },
  actions: {
    selectProvince({ dispatch, commit, rootState, state }, province) {
      let province_set = null;
      if (province != null) {
        province_set = "";
        let province_split = province.split(" ");
        for (let val of province_split) {
          province_set += val;
        }
        province_set = province_set.toLowerCase();
      }

      rootState.storeBack.store_name = null;
      if (province != null) {
        if (state.recent_province != province) {
          dispatch("resetState", null, { root: true });
        }
      }
      commit("selectProvince", province_set);
    },
    selectProvinceParam({ rootState, dispatch, commit, state }, province) {
      let province_set = null;
      if (province != null) {
        province_set = "";
        let province_split = province.split(" ");
        for (let val of province_split) {
          province_set += val;
        }
        province_set = province_set.toLowerCase();
      }

      if (province != null) {
        if (
          router.currentRoute.params.province &&
          state.province != router.currentRoute.params.province
        ) {
          dispatch("resetState", null, { root: true });
        }
      }
      commit("selectProvince", province_set);
    }
  },
  getters: {}
};
